export class ProjectActivityRequest {
    constructor(public projectName: string, public activityName: string ) {

    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/FineGrainedAuthorization/project-activity-request.ts
 **/